import {Component, OnInit} from '@angular/core';
import {KobeacService} from './kobeac.service';

/**
 * kobe-ac 売買台帳 (統合画面)。売買台帳の帳票作成・閲覧に関する3機能をタブで統合する:
 *  - 精算書   : kobeac-summary       (Stimulsoft ビューア/印刷)
 *  - 台帳一覧 : kobeac-ledger-list   (生成済み PDF の一覧・DL)
 *  - 請求編集 : kobeac-invoice-edit  (AC_Invoice_Head/Line 編集 + PDF再作成)
 *
 * <p>オークション日は当画面上部の共有セレクタ1つで選び、全タブ (auctionRid) に渡す。
 * 顧客は「精算書」の集計行クリックで確定し (customerSelected)、その顧客を「請求編集」
 * (customerRid) に渡す。各タブは埋め込み (embedded) 時に自前の日付/顧客セレクタを隠す。
 *
 * <p>各タブの中身は既存コンポーネントをそのまま埋め込む。重い初期化 (Stimulsoft ロードや
 * PDF 一覧スキャン) を避けるため、タブは初回表示時にのみ生成し (*ngIf visited)、以降は
 * [hidden] で残して状態を保持する (タブ切替で作り直さない)。
 */
@Component({
    standalone: false,
    selector: 'kobeac-ledger-home',
    templateUrl: 'ledger-home.component.html',
})
export class KobeacLedgerHomeComponent implements OnInit {
    tab: 'summary' | 'list' | 'invoice' = 'summary';
    visited: {summary: boolean; list: boolean; invoice: boolean} = {summary: true, list: false, invoice: false};

    auctions: any[] = [];
    selectedAuctionRid = '';
    selectedCustomerRid = '';
    selectedCustomerName = '';

    constructor(public kobeac: KobeacService) {
    }

    async ngOnInit(): Promise<void> {
        await this.kobeac.ensureLoaded();
        this.auctions = this.kobeac.auctions;
        if (this.auctions.length) {
            this.selectedAuctionRid = this.auctions[0]['@rid'];
        }
    }

    auctionLabel(a: any): string {
        return this.kobeac.formatOrientDate(a['日付']);
    }

    onAuctionChange(): void {
        // 日付を変えたら顧客選択はリセットする。
        this.selectedCustomerRid = '';
        this.selectedCustomerName = '';
    }

    /** 精算書の集計行で顧客が選ばれたら請求編集へ渡す。名前は表示用に解決する。 */
    onCustomerSelected(rid: string): void {
        this.selectedCustomerRid = rid;
        const c = this.kobeac.customers.filter((x: any) => x['@rid'] === rid);
        this.selectedCustomerName = c.length ? (c[0]['ID'] + ' ' + c[0]['名称']) : '';
    }

    select(tab: 'summary' | 'list' | 'invoice'): void {
        this.tab = tab;
        this.visited[tab] = true;
    }
}
